export default {"src":"/_next/static/media/clock-outline.e0781e5a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};